<template>
  <div class="app-container">
    <Navbar />
    <main class="content">
      <section id="hero"><Hero /></section>
      <section id="about"><About /></section>
      <section id="products"><Products /></section>
      <section id="partners"><Partners /></section>
    </main>
    <Footer />

    <!-- Scroll to Top Button -->
    <button v-show="showScrollTop" @click="scrollToTop" class="scroll-top">▲</button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Hero from "./components/Hero.vue";
import About from "./components/About.vue";
import Products from "./components/Products.vue";
import Partners from "./components/Partners.vue";

const showScrollTop = ref(false);

const handleScroll = () => {
  showScrollTop.value = window.scrollY > 300;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style>
/* Scroll to Top Button */
.scroll-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  font-size: 40px;
  color: #ffaa00; /* Orange arrow */
  border: none;
  background: none; /* No background */
  cursor: pointer;
  transition: transform 0.3s ease-in-out, opacity 0.3s;
  opacity: 0.7;
}

.scroll-top:hover {
  opacity: 1;
  transform: scale(1.2);
}
</style>